module.exports = __webpack_public_path__ + "static/media/celebration.57829744.svg";